import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { deleteUserRequest, deleteUserRequestError, deleteUserRequestSuccess } from "../../slices/user-management/DeleteUserSlice";


export const DeleteUserAPI = (id) => {
    return async (dispatch) => {
        try {
            dispatch(deleteUserRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.deleteUser,
                data: { userId: id },
            })
            return dispatch(deleteUserRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteUserRequestError(_error));
        }
    };
};
